module.exports = __webpack_public_path__ + "5f52cee7e9b74b4c332b9aa94ac9532e.png";